import gql from "graphql-tag";

export default gql`
  query GetDataQualityReviewState {
    getDataQualityReviewState {
      tenantId
      objectId
      environment
      revision
      snapshot_id
    }
  }
`;
